export default __webpack_public_path__ + "static/media/0.3d7bdd37.png";